import { useLocation, useNavigate } from 'react-router-dom'
import './Layout.css' 

const navItemsBase = [
  { 
    path: '/', 
    label: 'Inventario', 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
  },
  { 
    path: '/horarios', 
    label: 'Horarios', 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
  },
  { 
    path: '/citas', 
    label: 'Citas', 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
  },
  { 
    path: '/postventa', 
    label: 'Post-Venta CRM', 
    esPremium: true, 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path><path d="M12 7v5l2 2"></path></svg>
  },
  { 
    path: '/configuracion', 
    label: 'Configuración', 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
  },
  { 
    path: '/suscripcion', 
    label: 'Mi Suscripción', 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
  },
  { 
    path: '/whatsapp', 
    label: 'Conectar WhatsApp', 
    icon: <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
  },
]

export default function Sidebar({ open, onClose, onLogout, suscripcion }) {
  const location = useLocation()
  const navigate = useNavigate()

  const handleNav = (path) => {
    navigate(path)
    onClose()
  }

  const handleUpgrade = () => {
    navigate('/suscripcion')
    onClose()
  }

  if (!suscripcion) {
    return null; 
  }

  const isActiva = suscripcion.estado_suscripcion === 'activa'
  
  // 🛡️ Lógica blindada: Si no está activa, lo tratamos 100% como Trial ignorando la BDD
  const planNormalizado = isActiva && suscripcion.plan_actual ? suscripcion.plan_actual.toLowerCase() : 'trial'

  const isPremiumUnlocked = ['pro', 'premium', 'vip'].includes(planNormalizado)

  // Asignamos límites
  let maxCreditos = 50
  if (['premium', 'vip'].includes(planNormalizado)) maxCreditos = 10000
  else if (planNormalizado === 'pro') maxCreditos = 3500
  else if (planNormalizado === 'basico') maxCreditos = 1000

  // ⚖️ Balance de créditos: Si es Trial usa 'creditos_demo', sino 'mensajes_disponibles'
  const creditosActuales = isActiva 
    ? (suscripcion.mensajes_disponibles ?? 0) 
    : (suscripcion.creditos_demo ?? Math.min(suscripcion.mensajes_disponibles ?? 50, 50))

  const porcentaje = Math.max(0, Math.min(100, (creditosActuales / maxCreditos) * 100))
  const isBajo = creditosActuales <= (maxCreditos * 0.15)

  return (
    <>
      {open && <div className="layout-sidebar-overlay" onClick={onClose} />}
      
      <aside className={`layout-sidebar ${open ? 'open' : ''}`}>
        
        <div className="sidebar-brand">
          <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="brand-icon">
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>
          </svg>
          iStore
          {isActiva && (
            <span className="badge-pro">{planNormalizado.toUpperCase()}</span>
          )}
        </div>

        <nav className="sidebar-nav">
          {navItemsBase.map(item => {
            const isActive = location.pathname === item.path
            
            // Si el ítem es premium y el usuario no lo tiene, agregamos el candado visualmente
            const mostrarCandado = item.esPremium && !isPremiumUnlocked

            return (
              <button 
                key={item.path} 
                onClick={() => handleNav(item.path)} 
                className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
              >
                <span className="nav-item-icon" style={{ opacity: mostrarCandado ? 0.6 : 1 }}>
                  {item.icon}
                </span> 
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, opacity: mostrarCandado ? 0.6 : 1 }}>
                  {item.label}
                  {mostrarCandado && <span style={{ fontSize: '14px' }}>🔒</span>}
                </span>
              </button>
            )
          })}
        </nav>

        <div className="sidebar-upgrade-widget">
          <div className="widget-header">
            <span className="widget-title">
              {isActiva ? 'Consumo de Mensajes' : 'Prueba Gratuita 🚀'}
            </span>
          </div>
          <p className="widget-text">
            Te quedan <strong>{creditosActuales}</strong> de {maxCreditos} msjs
          </p>
          <div className="progress-bg">
            <div 
              className="progress-fill" 
              style={{ 
                width: `${porcentaje}%`, 
                backgroundColor: isBajo ? '#ef4444' : '#3b82f6' 
              }}
            />
          </div>
          
          <button className="btn-subscribe" onClick={handleUpgrade}>
            Comprar Plan
          </button>
        </div>

        <div className="sidebar-footer">
          <button onClick={onLogout} className="sidebar-logout-btn">
            <span className="nav-item-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
            </span>
            Cerrar sesión
          </button>
        </div>
      </aside>
    </>
  )
}